import {
  IMAGE_ACTION,
  IMAGE_ASPECT_RATIOS,
  IMAGE_MODE,
  IMAGE_MODEL_ID,
  PROVIDER,
} from 'Pods/ThreeDStudio/Store/constants'

// The frontend no longer starts inpaint runs - a brush edit is a multi-image-edit with
// overlay_mask - but stored runs still carry this model id, and imageActionOf classifies
// them through this schema. The backend also requires a mask asset, for which the
// frontend produces no canonical value, so it is not modelled here.
export default {
  "model_id": IMAGE_MODEL_ID.FLUX_INPAINT_FLUX1_FILL,
  "provider": PROVIDER.FLUX,
  "action": IMAGE_ACTION.INPAINT,
  "mode": IMAGE_MODE.FLUX1_FILL,
  "input_schema": {
    "type": "object",
    "properties": {
      "prompt": {
        "type": "string",
        "minLength": 1,
      },
      "input_image": {
        "type": "array",
        "minItems": 1,
        "maxItems": 1,
        "items": {
          "type": "object",
          "properties": { "asset_id": { "type": "integer" } },
          "required": ["asset_id"],
        },
      },
      "aspect_ratio": {
        "type": "string",
        "enum": IMAGE_ASPECT_RATIOS,
      },
      "num_images": {
        "type": "integer",
        "minimum": 1,
        "maximum": 4,
      },
    },
    "required": ["prompt", "input_image"],
  },
  "ui_schema": {},
}
